// extracted by mini-css-extract-plugin
module.exports = {"WelcomePage__content":"WelcomePage_WelcomePage__content__2FpAj","PageLayout__content":"WelcomePage_PageLayout__content__1GN-D"};